import styled              from 'styled-components/macro'
import { Map }             from 'components/Map/Map'

export const ViewMap = ({ showTooltip, hideTooltip }) => {
  
  return (
    <>
      {/* <AnimatePresence> */}
        <Container>
          <Map showTooltip={showTooltip} hideTooltip={hideTooltip}/>
        </Container>
        {/* <div style={{border:'10px solid orange',height:100,width:'100%'}}></div>  */}
      {/* </AnimatePresence> */}
    </>
  )
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  scrollbar-width: none;
  ::-webkit-scrollbar { display: none; }
`